import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SecurityIcon from '@mui/icons-material/Security';
import PaletteIcon from '@mui/icons-material/Palette';
import SavingsIcon from '@mui/icons-material/Savings';

export const featuresData = {
  header: {
    badge: {
      text: "Why Choose SnagEasy",
      icon: "CheckCircleIcon"
    },
    title: "Book your home inspection @SnagEasy & Protect Your Investment",
    description: "Our expert team have inspected 1300 apartments till now and helped in seamless possession. Smart Buying Starts Here: Ultimate Benefits of Expert Home Inspections..."
  },
  features: [
    {
      title: 'Ensure every penny should invested',
      text: 'Get a thorough home inspection to avoid costly surprises and make informed decisions, ensuring your investment is safe and sound.',
      icon: <TrendingUpIcon className="feature-icon" />,
      color: '#10B981'
    },
    {
      title: 'Reveal hidden defects',
      text: 'New homes often have hidden issues that can be easily fixed if detected early. Identifying these defects helps builders deliver flawless homes and saves on repair costs.',
      icon: <VisibilityIcon className="feature-icon" />,
      color: '#3B82F6'
    },
    {
      title: 'Help to avoid future emergencies',
      text: "Plumbing and electrical inspections ensure adherence to standards, preventing accidents and ensuring reliable water supply. Don't risk faulty systems—inspect for safety and efficiency.",
      icon: <SecurityIcon className="feature-icon" />,
      color: '#F59E0B',
    },
    {
      title: 'Beauty will remain for years',
      text: 'Minor wall cracks can worsen over time. A detailed inspection for paint shade variations, uneven surfaces, and paint overlaps ensures cosmetic corrections are made before you move in.',
      icon: <PaletteIcon className="feature-icon" />,
      color: '#8B5CF6'
    },
    {
      title: 'Avoid early expenses',
      text: 'Overlooked issues during home possession can lead to costly repairs later. A thorough inspection now prevents unexpected expenses in the future.',
      icon: <SavingsIcon className="feature-icon" />,
      color: '#EF4444'
    }
  ]
};
